// Generated by ReScript, PLEASE EDIT WITH CARE


var paymentSuccessHeader = "Your order is successfully placed";

var weAreBetterOnApp = "We are better on the app!";

var downloadNow = "Download now";

var successImgUrl = "https://dom-content-vault-prod-cdn-assets.porter.in/order_success_emphasis_b7e96603b9/order_success_emphasis_b7e96603b9.svg";

var orderDetailsImgUrl = "https://dom-content-vault-prod-cdn-assets.porter.in/order_details_placeholder_06072b6431/order_details_placeholder_06072b6431.png";

var paymentSuccessIconAlt = "payment success icon";

var orderDetailsIconAlt = "order details icon";

export {
  paymentSuccessHeader ,
  weAreBetterOnApp ,
  downloadNow ,
  successImgUrl ,
  orderDetailsImgUrl ,
  paymentSuccessIconAlt ,
  orderDetailsIconAlt ,
}
/* No side effect */
